module.exports = __webpack_public_path__ + "static/media/U_cihelny.8759b99a.md";